import { render, staticRenderFns } from "./CostStatistics.vue?vue&type=template&id=7e008572"
import script from "./CostStatistics.vue?vue&type=script&lang=ts"
export * from "./CostStatistics.vue?vue&type=script&lang=ts"
import style0 from "./CostStatistics.vue?vue&type=style&index=0&id=7e008572&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports